import { render, staticRenderFns } from "./editUploadKit.vue?vue&type=template&id=5c925706"
import script from "./editUploadKit.vue?vue&type=script&lang=js"
export * from "./editUploadKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports